import React from "react";
import { makeStyles } from "@material-ui/styles";
import AppLayout from "../components/Styles/AppLayout";
import LandingLayout from "../components/Styles/LandingLayout";
import LandingLinks from "../components/landingLinks";
import HeroImage from "../Images/index_hero.svg";

const useStyles = makeStyles(theme => ({
  hero: {
    minHeight: "300px",
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    alignItems: "center",
    padding: "2rem 0 0",
    "@media(max-width: 1024px)": {
      gridTemplateColumns: "1fr",
      marginBottom: "40px"
    },
    "@media(max-width: 667px)": {
      paddingTop: 0,
      height: "auto"
    }
  },
  heading: {
    fontSize: "4rem!important",
    fontWeight: `${900}!important`,
    lineHeight: 1.25,
    "@media(max-width: 1024px)": {
      textAlign: "center"
    }
  },
  imageContainer: {
    textAlign: "right",
    "@media(max-width: 1024px)": {
      textAlign: "center"
    }
  },
  heroImage: {
    height: "400px",
    width: "auto",
    "@media(max-width: 667px)": {
      height: "auto",
      width: "100%"
    }
  },
  linksOuter: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    minHeight: "600px",
    "@media(max-width: 667px)": {
      height: "auto"
    }
  },
  background: {
    position: "absolute",
    left: 0,
    right: 0,
    top: 0,
    bottom: 0
  },
  linksInner: { padding: "16px" },
  down: {}
}));

const IndexPage = ({ location }) => {
  const classes = useStyles();
  return (
    <AppLayout location={location}>
      <LandingLayout>
        <div className="doc__inner-container">
          <div className={classes.hero}>
            <h1 className={classes.heading}>
              Entry Event <br /> Docs
            </h1>
            <div className={classes.imageContainer}>
              <HeroImage className={classes.heroImage} />
            </div>
          </div>
          <div className={classes.linksOuter}>
            <div className={classes.linksInner}>
              <LandingLinks />
            </div>
          </div>
          <div className={classes.down}></div>
        </div>
      </LandingLayout>
    </AppLayout>
  );
};

export default IndexPage;
